import React, {
    FC,
    HTMLAttributeAnchorTarget,
    MouseEvent,
    ReactNode,
} from "react";
import { joinClassNames as c } from "Shared/util/styles";
import styles from "./text-link.css";

type TextLinkProps = {
    className?: string;
    disabled?: boolean;
    hrefSameTab?: boolean; // TODO (later) should only be available for HyperLinks
    link: LinkProps["onClick"] | HyperLinkProps["href"];
    text: string | ReactNode;
};

type LinkProps = Omit<TextLinkProps, "link"> & {
    onClick: (event?: MouseEvent<HTMLElement>) => void;
};

type HyperLinkProps = Omit<TextLinkProps, "link"> & {
    href: string;
    target: HTMLAttributeAnchorTarget;
};

const HyperLink: FC<HyperLinkProps> = ({
    className,
    disabled,
    href,
    target,
    text,
}) => (
    <a
        className={c(styles.link, disabled && styles.disabled, className)}
        href={href}
        rel="noopener noreferrer"
        target={target}
    >
        {text}
    </a>
);

const Link: FC<LinkProps> = ({ className, disabled, onClick, text }) => (
    <span
        className={c(styles.link, disabled && styles.disabled, className)}
        onClick={onClick}
    >
        {text}
    </span>
);

const TextLink: FC<TextLinkProps> = ({
    className,
    disabled,
    hrefSameTab,
    link,
    text,
}) =>
    typeof link === "function" ? (
        <Link
            className={className}
            disabled={disabled}
            onClick={link}
            text={text}
        />
    ) : (
        <HyperLink
            className={className}
            disabled={disabled}
            target={hrefSameTab ? "_self" : "_blank"}
            href={link}
            text={text}
        />
    );

export default TextLink;
